import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import TaskWizard from "@/pages/TaskWizard";
import Pricing from "@/pages/Pricing";
import Outstanding from "@/pages/Outstanding";
import Renewals from "@/pages/Renewals";
import ClientMonth from "@/pages/ClientMonth";
import ClientWorkspace from "@/pages/ClientWorkspace";
import Bundles from "@/pages/Bundles";
import ImportExcel from "@/pages/ImportExcel";
import Recurring from "@/pages/Recurring";
import AnnualTotals from "@/pages/AnnualTotals";
import Login from "@/pages/Login";
import ProtectedRoute from "@/components/ProtectedRoute";
import { BusinessProvider } from "@/context/BusinessContext";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BusinessProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/enter-work" element={<TaskWizard />} />
                <Route path="/workspace" element={<ClientWorkspace />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/client-month" element={<ClientMonth />} />
                <Route path="/outstanding" element={<Outstanding />} />
                <Route path="/renewals" element={<Renewals />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/bundles" element={<Bundles />} />
                <Route path="/recurring" element={<Recurring />} />
                <Route path="/annual" element={<AnnualTotals />} />
                <Route path="/import" element={<ImportExcel />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </BusinessProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
